'use strict';
const angular = require('angular');

/*@ngInject*/
export function ConfigService(PLATFORM_CONFIG, AppConfig) {
  // Service logic
  // ...

  let platformConfig = PLATFORM_CONFIG.data;

  platformConfig.getBaseUrl = () => platformConfig.baseURL;
  platformConfig.getTheme = () => platformConfig.theme;
  platformConfig.getBackground = () => platformConfig.background;
  platformConfig.getAnalyticsId = () => platformConfig.piwikSiteId;
  platformConfig.getMenuDefaultPermission = () => platformConfig.defaultMenuPermission;
  platformConfig.getUserRoles = () => platformConfig.userRoles;
  platformConfig.getPermissionRoles = () => platformConfig.permissionRoles || ["user"];
  platformConfig.getStorageContentTypes = () => platformConfig.storageContentType;
  platformConfig.getAdminNotificationAdresses = () => platformConfig.adminNotificationAddresses;
  platformConfig.getSystemSettings = () => platformConfig.systemSettings;
  platformConfig.getDefaultPermissionUserUpload = () => platformConfig.defaultUploadUserPermission || ["user"];
  platformConfig.getHomeImage = () => platformConfig.homeImage;
  platformConfig.getHomeText = () => platformConfig.homeText;
  platformConfig.getNavbarStyle = () => platformConfig.navbarStyle || 'default';
  platformConfig.getNavbarContainer = () => platformConfig.navbarContainer || 'container';
  platformConfig.getNavbarInterceptor = () => platformConfig.navbarInterceptor;
  platformConfig.getBaseContainerClass = () => platformConfig.baseContainerClass || 'container';
  platformConfig.getAccountAsMenu = () => platformConfig.accountAsMenu;
  platformConfig.getAllowedContentTypesForUpload = () => platformConfig.storageContentType;

  platformConfig.getManagementSuiteIntegratonSettings = () => platformConfig.managementSuite;

  // Private Platform Config specific settings

  let ConfigAPI = AppConfig;

  /**
   * Gets the raw config json for the platform
   */
  ConfigAPI.getPlatformConfig = () => platformConfig;

  // Public API here
  return ConfigAPI;
}

export default angular.module('conduu.ap.services.ConfigService', [])
  .factory('Config', ConfigService)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/services/config/config.service.js